<template>
    <div class="tablePage">
        <el-table
        stripe
            v-loading="loading"
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            :header-cell-style="headCellStyle"
            :cell-style="bodyCellStyle"
            :height="tableHeight"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="55" />
            <el-table-column :label="$t('probeunit.unit')" prop="name" show-overflow-tooltip />
            <el-table-column :label="$t('probeunit.table_unit_mark')" prop="title" show-overflow-tooltip />
            <el-table-column :label="$t('probeunit.table_unit_number')" prop="code" show-overflow-tooltip />
            <el-table-column :label="$t('probeunit.describe')" prop="desc" show-overflow-tooltip />
            <el-table-column
                :label="$t('tableTitle.Creation Time')"
                prop="keycode"
                show-overflow-tooltip
            >
                <template #default="{ row }">{{ $timetransition(row.createTime) }}</template>
            </el-table-column>
            <el-table-column :label="$t('probeunit.operation')" prop="operate" #default="{ row }" width="120px">
                <el-button
                    v-for="item in tableBtn"
                    :key="item.id"
                    type="text"
                    size="small"
                    @click="handle(row, item.method)"
                    :icon="item.icon"
                ></el-button>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    props: ['loading', 'tableData'],
    data() {
        return {
            tableHeight: '100%',
            tableBtn: [
                {
                    id: 1,
                    title: 'buttonTitle.Edit',
                    icon: this.$store.state.icons.edit,
                    method: "rowEdit",
                    vHas: [],
                },
                {
                    id: 3,
                    title: "buttonTitle.Delete",
                    icon: this.$store.state.icons.delete,
                    method: "rowDel",
                    vHas: [],
                },
            ]

        }
    },
    created() {
    },
    methods: {
        handleSelectionChange(arg) {
            this.$emit('selectRow',arg)
         },
        handle(row, method) {
            this.$emit(method, { ...row })
        }

    }
}
</script>

<style lang="scss" scoped>
.tablePage {
    height: calc(100% - 60px);
}
</style>
